import _ from 'lodash';
import { format } from '@jd/jmtd-tools/es/number';

export const userType = {
  DEPT: 'dept',
  ERP: 'erp',
  PLACE_DEPT: 'placeDept',
  PLACE_ERP: 'placeErp'
}
export function dropdownCheckboxData(online = 'REALTIME', type) {
  // 实时，离线，四种userType都有
  const child1 = {
    label: '流量',
    data: [
      {
        value: 'flow_item_detail_view_uv',
        label: '商详访问UV',
      },
    ],
  };
  // 实时+离线除运营部门外
  const child2 = {
    label: '用户',
    data: [
      {
        value: 'deal_buy_user_qtty',
        label: '成交购买用户',
      },
      {
        value: 'fo_old_time_buy_user_qtty',
        label: '老用户数',
      },
    ],
  };
  // 离线的运营部门
  const child3 = {
    label: '用户',
    data: [
      {
        value: 'deal_buy_user_qtty',
        label: '成交购买用户',
      },
      {
        value: 'fo_old_time_buy_user_qtty',
        label: '老用户数',
      },
      {
        value: 'uo_latest_valid_user_cnt-IN_NEW_DEPT',
        label: '部门站内新',
      },
      {
        value: 'uo_latest_valid_user_cnt-OUT_NEW_DEPT',
        label: '部门站外新',
      },
    ],
  };
  // 实时，离线，四种userType都有
  const child4 = {
    label: '交易',
    data: [
      {
        value: 'ge_deal_standard_deal_ord_amt',
        label: '成交金额',
      },
    ],
  };
  //离线的dept erp
  const child5 = {
    label: '商品',
    data: [
      {
        value: 'ma_stat_for_sale_item_qtty',
        label: '在售SKU数',
      },
      {
        value: 'ma_stat_dynamic_sale_item_qtty',
        label: '动销SKU数',
      },
    ],
  };

  const result = [];
  if (online === 'REALTIME') {
    result.push(child1, child2, child4);
  } else {
    if (type === userType.DEPT) {
      result.push(child1, child3, child4, child5);
    } else if (type === userType.ERP) {
      result.push(child1, child2, child4, child5);
    } else if (type === userType.PLACE_DEPT || type === userType.PLACE_ERP) {
      result.push(child1, child2, child4);
    }
  }
  return result;
}

const checkboxList = [
  {
    value: 'flow_item_detail_view_uv',
    label: '商详访问UV',
    type: '流量',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'deal_buy_user_qtty',
    label: '成交购买用户',
    type: '用户',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'fo_old_time_buy_user_qtty',
    label: '老用户数',
    type: '用户',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_deal_ord_amt',
    label: '成交金额',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-IN_NEW_DEPT',
    label: '部门站内新-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-OUT_NEW_DEPT',
    label: '部门站外新-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'ma_stat_for_sale_item_qtty',
    label: '在售SKU数',
    type: '商品',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'ma_stat_dynamic_sale_item_qtty',
    label: '动销SKU数',
    type: '商品',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-OUT_BACK_RETAIL',
    label: '回流用户-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-OUT_NEW_RETAIL',
    label: '站外新用户-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-OLD_RETAIL',
    label: '老用户-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'eff_buy_user_qtty',
    label: '有效购买用户',
    type: '用户',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-OUT_BACK_RETAIL',
    label: '回流用户-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-OUT_NEW_RETAIL',
    label: '站外新用户-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-OLD_RETAIL',
    label: '老用户-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-IN_NEW_DEPT',
    label: '部门站内新-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-OUT_NEW_DEPT',
    label: '部门站外新-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_deal_user_cnt-OLD_DEPT',
    label: '部门老用户-成交',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'uo_latest_valid_user_cnt-OLD_DEPT',
    label: '部门老用户-有效',
    type: '用户',
    dept: true,
    erp: false,
    placeDept: false,
    placeErp: false,
    REALTIME: false,
    OFFLINE: true,
  },
  {
    value: 'flow_item_detail_view_pv',
    label: '商详PV',
    type: '流量',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_deal_item_qtty',
    label: '成交数量',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_deal_sub_ord_qtty',
    label: '成交子单量',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_out_ord_amt',
    label: '出库金额',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_out_ord_item_qtty',
    label: '出库件数',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'ge_deal_standard_out_sub_ord_qtty',
    label: '出库子单量',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'fo_ge_deal_app_atv',
    label: '成交客单价',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
  {
    value: 'fo_flow_item_detail_view_uv_user_per',
    label: '成交转化率',
    type: '交易',
    dept: true,
    erp: true,
    placeDept: true,
    placeErp: true,
    REALTIME: true,
    OFFLINE: true,
  },
];

export function dropdownCheckboxDataV2(online = 'REALTIME', type) {
  let result = checkboxList.filter((item)=>(item[type] && item[online]))
  let idList = result.map((item)=>(item.value))
  let dataInfo = {};
  result.forEach((item, index) => {
    let { type } = item;
    if (!dataInfo[type]) {
      dataInfo[type] = {
        label:type,
        data: []
      }
    }
    dataInfo[type].data.push(item);
  });
  let list = Object.values(dataInfo); // list 转换成功的数据

  return {
    indexList:list,
    idList
  }
}

export const defaultCheckboxIndex = ['flow_item_detail_view_uv','deal_buy_user_qtty', 'fo_old_time_buy_user_qtty', 'ge_deal_standard_deal_ord_amt']

//拼接中划线-+大写字母为指标市场条件
export const indexIdList = [
  'flow_item_detail_view_uv',
  'flow_item_detail_view_pv', // 商详PV
  'deal_buy_user_qtty',
  'fo_old_time_buy_user_qtty',
  'uo_latest_valid_user_cnt-IN_NEW_DEPT',
  'uo_latest_valid_user_cnt-OUT_NEW_DEPT',
  'uo_latest_deal_user_cnt-OUT_BACK_RETAIL',
  'uo_latest_deal_user_cnt-OUT_NEW_RETAIL',
  'uo_latest_deal_user_cnt-OLD_RETAIL',
  'eff_buy_user_qtty',
  'uo_latest_valid_user_cnt-OUT_BACK_RETAIL',
  'uo_latest_valid_user_cnt-OUT_NEW_RETAIL',
  'uo_latest_valid_user_cnt-OLD_RETAIL',
  'uo_latest_deal_user_cnt-IN_NEW_DEPT',
  'uo_latest_deal_user_cnt-OUT_NEW_DEPT',
  'uo_latest_deal_user_cnt-OLD_DEPT',
  'uo_latest_valid_user_cnt-OLD_DEPT',
  'ge_deal_standard_deal_ord_amt',
  'ma_stat_for_sale_item_qtty',
  'ma_stat_dynamic_sale_item_qtty',
  'ge_deal_standard_deal_item_qtty',
  'ge_deal_standard_deal_sub_ord_qtty',
  'ge_deal_standard_out_ord_amt',
  'ge_deal_standard_out_ord_item_qtty',
  'ge_deal_standard_out_sub_ord_qtty',
  'fo_ge_deal_app_atv',
  'fo_flow_item_detail_view_uv_user_per'
]
export const summaryList = {
  'flow_item_detail_view_uv': {
    value: 'flow_item_detail_view_uv',
    des: '统计周期内，访问过商品详情页面的独立访客数。',
    name: '商详访问UV',
    type: 1,
  },
  'deal_buy_user_qtty': {
    value: 'deal_buy_user_qtty',
    des: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交支付（货到下单）且未取消订单的用户数，跨天为按日累加。',
    name: '成交购买用户',
    type: 1,
  },
  'fo_old_time_buy_user_qtty': {
    value: 'fo_old_time_buy_user_qtty',
    des: '有效口径，指购买两次及以上的用户数，即有效购买用户-首购用户。',
    name: '老用户数',
    type: 1,
  },
  'uo_latest_valid_user_cnt-IN_NEW_DEPT': {
    value: 'uo_latest_valid_user_cnt-IN_NEW_DEPT',
    des: '历史第一次成交支付（活到下单）该部门商品订单但非全站首次购的用户数。',
    name: '部门站内新-有效',
    type: 1,
  },
  'uo_latest_valid_user_cnt-OUT_NEW_DEPT': {
    value: 'uo_latest_valid_user_cnt-OUT_NEW_DEPT',
    des: '全平台第一次成交支付（货到下单）且购买该部门商品的用户数。',
    name: '部门站外新-有效',
    type: 1,
  },
  'ge_deal_standard_deal_ord_amt': {
    value: 'ge_deal_standard_deal_ord_amt',
    des: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
    name: '成交金额',
    type: 5,
  },
  'ma_stat_for_sale_item_qtty': {
    value: 'ma_stat_for_sale_item_qtty',
    des: '主站在售商品数',
    name: '在售SKU数',
    type: 1,
  },
  'ma_stat_dynamic_sale_item_qtty': {
    value: 'ma_stat_dynamic_sale_item_qtty',
    des: '主站有动销的商品数',
    name: '动销SKU数',
    type: 1,
  },
  'uo_latest_deal_user_cnt-OUT_BACK_RETAIL': {
    value: 'uo_latest_deal_user_cnt-OUT_BACK_RETAIL',
    des: '历史在京东有购物，近4个季度（包含当前季度）未发生购买，在当日成交支付（货到下单）且未取消订单的用户数。',
    name: '回流用户-成交',
    type: 1,
  },
  'uo_latest_deal_user_cnt-OUT_NEW_RETAIL': {
    value: 'uo_latest_deal_user_cnt-OUT_NEW_RETAIL',
    des: '全平台第一次成交支付（货到下单）未取消的用户数。',
    name: '站外新用户-成交',
    type: 1,
  },
  'uo_latest_deal_user_cnt-OLD_RETAIL': {
    value: 'uo_latest_deal_user_cnt-OLD_RETAIL',
    des: '老用户（成交）=成交购买用户-回流用户（成交）-站外新用户（成交）。',
    name: '老用户-成交',
    type: 1,
  },
  'eff_buy_user_qtty': {
    value: 'eff_buy_user_qtty',
    des: '以订单下单时间统计，统计周期内，成功提交且未取消订单的用户数，剔除十万以上未支付订单、内采等，跨天为按日累加。',
    name: '有效购买用户',
    type: 1,
  },
  'uo_latest_valid_user_cnt-OUT_BACK_RETAIL': {
    value: 'uo_latest_valid_user_cnt-OUT_BACK_RETAIL',
    des: '历史在京东有购物，近4个季度（包含当前季度）未发生购买，在当日成功提交且未取消订单的用户数。',
    name: '回流用户-有效',
    type: 1,
  },
  'uo_latest_valid_user_cnt-OUT_NEW_RETAIL': {
    value: 'uo_latest_valid_user_cnt-OUT_NEW_RETAIL',
    des: '全平台第一次成功提交且未取消的用户数。',
    name: '站外新用户-有效',
    type: 1,
  },
  'uo_latest_valid_user_cnt-OLD_RETAIL': {
    value: 'uo_latest_valid_user_cnt-OLD_RETAIL',
    des: '老用户（有效）=有效购买用户-回流用户（有效）-站外新用户（有效）。',
    name: '老用户-有效',
    type: 1,
  },
  'uo_latest_deal_user_cnt-IN_NEW_DEPT': {
    value: 'uo_latest_deal_user_cnt-IN_NEW_DEPT',
    des: '历史第一次成功提交该部门商品订单但非全站首次购的用户数。',
    name: '部门站内新-成交',
    type: 1,
  },
  'uo_latest_deal_user_cnt-OUT_NEW_DEPT': {
    value: 'uo_latest_deal_user_cnt-OUT_NEW_DEPT',
    des: '全平台第一次成功提交未取消且购买该部门商品的用户数。',
    name: '部门站外新-成交',
    type: 1,
  },
  'uo_latest_deal_user_cnt-OLD_DEPT': {
    value: 'uo_latest_deal_user_cnt-OLD_DEPT',
    des: '老用户（成交）=成交购买用户-站内新用户（成交）-站外新用户（成交）',
    name: '部门老用户-成交',
    type: 1,
  },
  'uo_latest_valid_user_cnt-OLD_DEPT': {
    value: 'uo_latest_valid_user_cnt-OLD_DEPT',
    des: '老用户（有效）=有效购买用户-站内新用户（有效）-站外新用户（有效）。',
    name: '部门老用户-有效',
    type: 1,
  },
  'flow_item_detail_view_pv': {
    value: 'flow_item_detail_view_pv',
    des: '统计周期内，商品详情页面被访问的次数。',
    name: '商详PV',
    type: 1,
  },
  'ge_deal_standard_deal_item_qtty': {
    value: 'ge_deal_standard_deal_item_qtty',
    des: '在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：营销中心剔除非金融内采和礼品卡类目订单，商智不剔除。',
    name: '成交数量',
    type: 1,
  },
  'ge_deal_standard_deal_sub_ord_qtty': {
    value: 'ge_deal_standard_deal_sub_ord_qtty',
    des: '在线以订单支付时间统计，货到以下单时间统计，统计周期内的成交子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。 与商智的差异：营销中心剔除非金融内采和礼品卡类目订单，商智不剔除。',
    name: '成交子单量',
    type: 1,
  },
  'ge_deal_standard_out_ord_amt': {
    value: 'ge_deal_standard_out_ord_amt',
    des: '出库金额实物以订单出库时间统计，虚拟以对账时间统计，统计周期内，出库订单包含的商品总金额。金额 = 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销）促销优惠金额 – 所有优惠券金额+全球购税费+运费+服务费。',
    name: '出库金额',
    type: 5,
  },
  'ge_deal_standard_out_ord_item_qtty': {
    value: 'ge_deal_standard_out_ord_item_qtty',
    des: '出库数量实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库商品数量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
    name: '出库件数',
    type: 1,
  },
  'ge_deal_standard_out_sub_ord_qtty': {
    value: 'ge_deal_standard_out_sub_ord_qtty',
    des: '出库子单实物以订单出库时间统计，虚拟以对账时间统计，统计周期内的出库子订单量，剔除十万以上未支付订单、内采订单、售后换新订单、1元秒杀拼团、三级礼品卡类目、误购取件费订单。',
    name: '出库子单量',
    type: 1,
  },
  'fo_ge_deal_app_atv': {
    value: 'fo_ge_deal_app_atv',
    des: '成交金额/成交子单量',
    name: '成交客单价',
    type: 5,
  },
  'fo_flow_item_detail_view_uv_user_per': {
    value: 'fo_flow_item_detail_view_uv_user_per',
    des: '成交购买用户/商详UV',
    name: '成交转化率',
    type: 2,
  },
}

export function getJmtdValFormatter(type) {
  switch (type) {
    case 1:
      return 'number_0_0';
    case 2:
      return 'percent_2_0_1';
    case 4:
      return 'number_2_0';
    case 5:
      return 'currency_¥';
    case 6:
      return 'currency_¥_2';
    default:
      return null;
  }
}

export function getSummaryData(data, selectedIndex){
  if(_.isEmpty(data) || _.isEmpty(data.index)) return []
  const list = data.index;
  console.log({selectedIndex})
  const result = selectedIndex.map(index=>{
    const norms = [{
      code: "ratio",
      name: "较对比日",
      type: 2,
      value:list[`${index}_ratio`],
    }]
    if(list.hasOwnProperty(`${index}_app_ratio`)){
      norms.push({
        code: "app_ratio",
        name: "APP占比",
        type: 2,
        value:list[`${index}_app_ratio`],
      })
    }
    const obj = {
      ...summaryList[index],
      data: list[index],
      norms
    }
    return obj
  })
  return result
}
//离线是0
export const timeGranularityList = [
  {
    value: 0,
    label: '分段'
  },
  {
    value: 1,
    label: '累计'
  }
];
export const chartConfig = () => {
  return {
    formatter(value, { seriesName }, pointData) {
      return format(value, pointData.type);
    },
    config: {
      height: 150,
      legend: {
        type: 'scroll',
      },
      yAxis: [
        {
          type: 'value',
        },
        {
          type: 'value',
          position: 'right', // 多选时百分比轴展示在右侧
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter(val) {
              return format(val, 'percent_2_0_1');
            },
          },
        },
      ],
      grid: {
        left: 70,
        right: 100,
      },
    },
  };
};